import styled from '@emotion/styled';

import Alert from 'components/global/Alert';

export const ModalContainer = styled.div`
	padding: 2rem 0;
`;

export const OnboardingAlert = styled(Alert)`
	margin: 1rem;
`;
